import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeDynamicClusterComponent } from './cluster/cluster.component';
import { MeDynamicReportComponent } from './dynamic-report.component';
import { MeDynamicOnboardingComponent } from './onboarding/onboarding.component';
import { MeDynamicOverviewCardComponent } from './overview-card/overview-card.component';
import { MeDynamicSubClusterComponent } from './sub-cluster/sub-cluster.component';

const routes: Routes = [
    { path: '', component: MeDynamicReportComponent },
    { path: 'onboarding', component: MeDynamicOnboardingComponent },
    { path: 'clusters/:slug', component: MeDynamicClusterComponent },
    { path: 'clusters/:slug/:subClusterId', component: MeDynamicSubClusterComponent },
    { path: 'overview-card', component: MeDynamicOverviewCardComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MeDynamicReportRoutesModule {

}
